export default {
  namespaced: true,

  state: {
    installApp: false,
  },

  getters: {
    installable: state => !!state.installApp,
  },

  actions: {
    install({ state }) { state.installApp() },
  },

  mutations: {
    SET_FN(state, fn) { state.installApp = fn },
  },
}
